import React from "react";
import { Button, Input, Label, Row, Col, FormGroup } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import t from "utils/Lang";
import api from "../../api";
import "./index.css";

const contactFields = [
  {
    codeName: "last_name",
    name: t().site_contact_modal__last_name,
    type: "text",
    xs: 12,
    sm: 4,
  },
  {
    codeName: "middle_name",
    name: t().site_contact_modal__middle_name,
    type: "text",
    xs: 12,
    sm: 4,
  },
  {
    codeName: "first_name",
    name: t().site_contact_modal__first_name,
    type: "text",
    xs: 12,
    sm: 4,
  },
  {
    codeName: "primary_phone",
    name: t().site_contact_modal__primary_phone,
    type: "text",
    xs: 12,
    sm: 6,
  },
  {
    codeName: "secondary_phone",
    name: t().site_contact_modal__secondary_phone,
    type: "text",
    xs: 12,
    sm: 6,
  },
  {
    codeName: "email",
    name: t().site_contact_modal__email,
    type: "text",
    xs: 12,
    sm: 6,
  },
  {
    codeName: "home_address",
    name: t().site_contact_modal__home_address,
    type: "text",
    xs: 12,
    sm: 12,
  },
  {
    codeName: "work_address",
    name: t().site_contact_modal__work_address,
    type: "text",
    xs: 12,
    sm: 12,
  },
  {
    codeName: "note",
    name: t().site_contact_modal__note,
    type: "textarea",
    xs: 12,
    sm: 12,
  },
];

export default class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCreateNewContact: this.props.isCreateNewContact || false,
      locationContact: this.props.locationContact || {},
      contact: this.props.locationContact
        ? this.props.locationContact.contact
        : {},
      isEdit: false,
      contactTypes: [],
      isModalOpen: this.props.isModalOpen || true,
    };
    this.removeContactFromLocation = this.removeContactFromLocation.bind(this);
    this.submitContactData = this.submitContactData.bind(this);
    this.submitLocationContactData = this.submitLocationContactData.bind(this);
    this.getContactType = this.getContactType.bind(this);
  }
  componentDidMount() {
    const { isCreateNewContact } = this.props;
    if (isCreateNewContact) {
      this.getContactType();
    }
  }
  getCurrentUser(callback) {
    // this.setState({isModalOpen: false})
    api.fetchAPI({
      method: "get",
      uri: `userme/me`,
      success: (response) => {
        console.log(response);
        if (response.result) {
          const currentUser = response.result;
          this.setState(
            {
              currentUser,
              // isModalOpen: false,
            },
            () => {
              if (callback) {
                callback();
              }
            }
          );
        } else {
          alert("Failed to get user: " + response.msg);
        }
      },
      error: (error) => {
        console.error(error);
        this.setState({
          isModalOpen: false,
        });
      },
    });
  }
  getContactType() {
    api.fetchAPI({
      method: "get",
      uri: `contact_type/?q=(filters:!((col:is_active,opr:eq,value:1)))`,
      success: (response) => {
        console.log(response);
        if (response.result) {
          this.setState({
            contactTypes: response.result,
          });
        } else {
          alert(response.msg);
        }
      },
    });
  }
  removeContactFromLocation() {
    const { isSite } = this.props;
    const { locationContact, currentUser } = this.state;
    const confirmation = window.confirm(
      "Bạn có chắc sẽ xóa người này khỏi mặt bằng?"
    );
    if (!confirmation) return;

    const bodyToUpload = {
      id: locationContact.id,
      is_active: 0,
      changed_by: {
        id: currentUser.id,
      },
    };

    let uri = `location_contact/${bodyToUpload.id}`;
    if (isSite) {
      uri = `site_contact/${bodyToUpload.id}`;
    }

    api.fetchAPI({
      method: "put",
      body: bodyToUpload,
      uri,
      success: (response) => {
        this.setState({
          locationContact: null,
        });
      },
    });
  }
  submitContactData() {
    const { contact, currentUser, isEdit } = this.state;

    if (isEdit) {
      contact.changed_by = {
        id: currentUser.id,
      };

      contact.created_by = {
        id: currentUser.id,
      };

      api.fetchAPI({
        method: "put",
        body: contact,
        uri: `contact/${contact.id}`,
        success: (response) => {
          if (response.result) {
            this.setState(
              {
                contact,
              },
              this.submitLocationContactData
            );
          }
        },
      });
    } else {
      this.submitLocationContactData();
    }
  }
  submitLocationContactData() {
    const { locationId, isSite } = this.props;
    const {
      contact,
      currentUser,
      locationContact,
      isEdit,
      isCreateNewContact,
    } = this.state;

    if (!contact.brand_id) {
      contact.brand_id = currentUser.user_brand.brand_id;
    }

    if (!contact.created_by) {
      contact.created_by_fk = currentUser.id;
      contact.changed_by_fk = currentUser.id;
    }

    const locationContactToUpload = {
      contact,
      changed_by: {
        id: currentUser.id,
      },
      is_property_owner: locationContact.is_property_owner,
      relationship_with_owner: locationContact.relationship_with_owner,
    };

    if (isSite) {
      locationContactToUpload.site = {
        id: locationId,
      };
    } else {
      locationContactToUpload.contact = {
        id: locationId,
      };
    }

    if (isEdit && locationContact.id) {
      locationContactToUpload.id = locationContact.id;
    }

    if (isCreateNewContact) {
      locationContactToUpload.created_by = {
        id: currentUser.id,
      };
    }

    console.log("locationContact", locationContact);
    console.log("locationContactToUpload", locationContactToUpload);

    let uri = isEdit
      ? `location_contact/${locationContactToUpload.id}`
      : "location_contact/";
    if (isSite) {
      uri = isEdit
        ? `site_contact/${locationContactToUpload.id}`
        : "site_contact/";
    }

    api.fetchAPI({
      method: isEdit ? "put" : "post",
      body: locationContactToUpload,
      uri,
      success: (response) => {
        if (response.result) {
          const result = response.result;

          if (!locationContactToUpload.id) {
            // This is for create process
            locationContactToUpload.id = response.id;
          }
          locationContactToUpload.is_property_owner = result.is_property_owner;
          locationContactToUpload.relationship_with_owner =
            result.relationship_with_owner;

          if (contact && !contact.id) {
            contact.id = result.contact;
          }

          locationContactToUpload.contact = contact;

          this.setState(
            {
              isCreateNewContact: false,
              locationContact: locationContactToUpload,
              contact,
              isEdit: false,
            },
            () => {
              if (this.props.onContactCreated) {
                this.props.onContactCreated(locationContactToUpload);
              }
            }
          );
        } else {
          alert(response.msg);
        }
      },
    });
  }
  updateContactAttr(attributeName, value) {
    const { contact } = this.state;
    if (attributeName == "contact_type") {
      contact[attributeName] = {
        id: value,
      };
    } else {
      contact[attributeName] = value;
    }
    this.setState({ contact });
  }
  updateLocationContactAttr(attributeName, value) {
    const { locationContact } = this.state;
    locationContact[attributeName] = value;
    this.setState({ locationContact });
  }
  toogleModal() {
    const { isModalOpen } = this.state;
    const { onModalClose } = this.props;
    this.setState(
      {
        isModalOpen: !isModalOpen,
        isEdit: false,
        isCreateNewContact: false,
      },
      () => {
        if (onModalClose) {
          onModalClose();
        }
      }
    );
  }
  render() {
    const {
      isCreateNewContact,
      isEdit,
      locationContact,
      contact,
      contactTypes,
      isModalOpen,
    } = this.state;
    if (!locationContact) return null;
    // Edit and create mode
    if (isCreateNewContact || isEdit) {
      return (
        <Modal
          isOpen={isModalOpen}
          size="lg"
          centered
          toggle={() => this.toogleModal()}
        >
          <ModalHeader toggle={() => this.toogleModal()}>
            {!isEdit ? "Tạo mới" : "Chỉnh sửa"}
          </ModalHeader>
          <ModalBody>
            <Row>
              {contactFields.map((contactField) => (
                <Col
                  key={contactField.codeName}
                  xs={contactField.xs}
                  sm={contactField.sm}
                >
                  <FormGroup>
                    <Label>{contactField.name}</Label>
                    <Input
                      type={contactField.type}
                      placeholder={contactField.name}
                      value={contact[contactField.codeName]}
                      onChange={(e) =>
                        this.updateContactAttr(
                          contactField.codeName,
                          e.target.value
                        )
                      }
                    />
                  </FormGroup>
                </Col>
              ))}
              <Col xs={12}>
                <FormGroup>
                  <Label>{t().site_contact_modal__customer_type}</Label>
                  <Input
                    type="select"
                    value={contact.contact_type}
                    onChange={(e) =>
                      this.updateContactAttr("contact_type_id", e.target.value)
                    }
                  >
                    <option>{t().site_contact_modal__select_an_option}</option>
                    {contactTypes.map((contactType) => (
                      <option key={contactType.id} value={contactType.id}>
                        {contactType.name}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col xs={12} sm={6}>
                <FormGroup>
                  <Label>{t().site_contact_modal_is_host}</Label>
                  <Input
                    type="select"
                    value={locationContact.is_property_owner ? "1" : "0"}
                    onChange={(e) =>
                      this.updateLocationContactAttr(
                        "is_property_owner",
                        e.target.value
                      )
                    }
                  >
                    <option>{t().site_contact_modal__select_an_option}</option>
                    <option value="1">{t().action__yes}</option>
                    <option value="0">{t().action__no}</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col xs={12} sm={6}>
                <FormGroup>
                  <Label>{t().site_contact_modal_relationship_host}</Label>
                  <Input
                    type="text"
                    value={locationContact.relationship_with_owner}
                    onChange={(e) =>
                      this.updateLocationContactAttr(
                        "relationship_with_owner",
                        e.target.value
                      )
                    }
                  />
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              onClick={() => this.getCurrentUser(this.submitContactData)}
            >
              {t().action__save}
            </Button>{" "}
            <Button color="secondary" onClick={() => this.toogleModal()}>
              {t().action__cancel}
            </Button>
          </ModalFooter>
        </Modal>
      );
    }

    // View mode
    if (!locationContact || !locationContact.contact) return null;
    return (
      <div className="contact__main">
        <h3 className="contact__name">
          {contact.last_name} {contact.middle_name} {contact.first_name}
          {locationContact.is_property_owner && (
            <span className="contact__property-owner">
              {t().site_contact_modal_host}
            </span>
          )}
          {locationContact.relationship_with_owner && (
            <span className="contact__relationship">
              {locationContact.relationship_with_owner}
            </span>
          )}
        </h3>
        <div className="contact__info-wrapper">
          <p>
            {t().site_contact_modal_phone_number}: {contact.primary_phone} -{" "}
            {contact.secondary_phone}
          </p>
          <p>Email: {contact.email}</p>
          <p>
            {t().site_listing__address}: {contact.home_address}
          </p>
        </div>
        <div className="contact__row">
          <Button
            outline
            size="sm"
            color="info"
            onClick={() =>
              this.setState(
                { isCreateNewContact: true, isEdit: true },
                this.getContactType
              )
            }
          >
            {t().action__edit}
          </Button>
          <Button
            style={{ marginLeft: 15 }}
            outline
            size="sm"
            color="danger"
            onClick={() => this.getCurrentUser(this.removeContactFromLocation)}
          >
            {t().action__remove}
          </Button>
        </div>
      </div>
    );
  }
}
